import { Fragment } from 'react';
import Card from '../ui/Card';
import Closebutton from '../ui/Closebutton';

import Item from '../ui/Item';
import peperroni from '../../img/peperroni.jpeg';
import mushpizza from '../../img/mushpizza.jpeg';
import salami from '../../img/salami.jpeg';
import specialpiz from '../../img/specialpiz.jpeg';
import vegpizza from '../../img/vegpizza.jpeg';
import garlicbread from '../../img/garlicbread.jpeg';
import shrimppiza from '../../img/shrimppiz.jpeg';


const dummy_data = [
    {
        key:'d1',
        name:'Peperroni',
        price:95000 ,
        icon:peperroni,
description:'X1/X2/Family',
    },
    {
        key:'d2',
        name:'Mushroom',
        price:85000,
        icon:mushpizza,
        description:'X1/X2/Family',
    },
    {
        key:'d3',
        name:'Salami',
        price:95000,
        icon:salami,
        description:'X1/X2/Family',
    },
    {
        key:'d4',
        name:'Special',
        price:105000 ,
        icon:specialpiz,
        description:'X1/X2/Family',
    },
    {
        key:'d5',
        name:'Vegeterian',
        price:90000,
        icon:vegpizza,
        description:'X1/X2/Family',
    },
    {
        key:'d6',
        name:'Garlic Bread',
        price:60000,
        icon:garlicbread,
        description:'X1/X2/Family',
    },
    {
        key:'d7',
        name:'Shrimp Pizza',
        price:120000 ,
        icon:shrimppiza,
        description:'X1/X2/Family',
    }
  
] ;


const Foods = (props) => {

    const drinksList = dummy_data.map((food) => (
 
    <Item
      key={food.id}
      name={food.name}
      price={food.price}
      icon={food.icon}
      description={food.description}
    />
  ));
   
  return (
<Fragment>
<Closebutton onClick={props.onClick} />
<Card>

{drinksList}

   </Card>
   </Fragment>
   )
}


export default Foods;